const translations = {
    create: 'create',
    nextPlanTheFlight: 'next: plan the flight'
};

export default translations;
